import { createContext } from 'react';

import type { TruncationMode } from '@dynatrace/strato-components/typography';

export const HoneycombTruncationMode = createContext<TruncationMode>('middle');
